import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Stack,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from '@mui/material';
import { Facebook, Twitter, Email, WhatsApp } from '@mui/icons-material';
import ShareIcon from '@mui/icons-material/Share';

const ShareButton = ({
  shareLink,
  shareprofile,
  passkey,
  shareLabel = 'Invite',
  onClick,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = useState(false);

  const handleClick = async (event) => {
    if (onClick) {
      setLoading(true);
      await onClick();
      setLoading(false);
      setAnchorEl(event.currentTarget);
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyLink = () => {
    const message = `${shareLink}`;

    navigator.clipboard.writeText(message);
    setAnchorEl(null);
  };

  const shareOptions = [
    {
      icon: <Facebook sx={{ mr: '12px' }} />,
      label: 'Facebook',
      url: 'https://www.facebook.com/sharer/sharer.php?u=',
    },
    {
      icon: <Twitter sx={{ mr: '12px' }} />,
      label: 'Twitter',
      url: 'https://twitter.com/intent/tweet?url=',
    },
    {
      icon: <Email sx={{ mr: '12px' }} />,
      label: 'Email',
      url: 'mailto:?body=',
    },
    {
      icon: <WhatsApp sx={{ mr: '12px' }} />,
      label: 'WhatsApp',
      url: 'https://api.whatsapp.com/send?text=',
    },
  ];

  return (
    <Stack width={'inherit'}>
      <Button
        variant='contained'
        onClick={handleClick}
        startIcon={
          loading ? (
            <CircularProgress size={20} color='inherit' />
          ) : (
            <ShareIcon />
          )
        }
        disabled={loading}
        fullWidth={isMobile}
        color='primary'
        sx={{
          fontWeight: 'bold',
          backgroundColor: 'primary.main',
          color: 'white',
          '&:hover': {
            backgroundColor: 'primary.main',
            color: 'white',
          },
          textTransform: 'none',
        }}
      >
        {loading ? 'Generating...' : shareLabel}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {shareOptions.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() =>
              window.open(option.url + encodeURIComponent(shareLink), '_blank')
            }
          >
            {option.icon}
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
};

export default ShareButton;
